module.exports = __webpack_public_path__ + "static/media/wa-background-dark.58c33377.jpg";